import { gql } from 'apollo-angular';

export const KPI_MASTER_QUERY = gql`
  query kpisMasters {
    kpisMasters {
      id
      name
    }
  }
`;

export const KPIS_CATALOG_QUERY = gql`
  query KpisCatalog($filter: KpisCatalogInput) {
    kpisCatalog(filter: $filter) {
      id
      name
      isAverage
      kpiMeasure
      categories {
        id
        name
      }
      types {
        id
        name
      }
    }
  }
`;

export const PLAYER_COMPETITION_KPI_QUERY = gql`
  query PlayerCompetitionKpis($filter: PlayerCompetitionKpisInput) {
    playerCompetitionKpis(filter: $filter) {
      competitionId
      seasonId
      kpiMasterId
      playerId
      value
      clubId
    }
  }
`;

export const PLAYER_GAME_KPI_QUERY = gql`
  query PlayerGameKpis($filter: PlayerGameKpisInput) {
    playerGameKpis(filter: $filter) {
      gameId
      seasonId
      competitionId
      kpiMasterId
      playerId
      value
    }
  }
`;

export const PLAYER_GAME_KPIS_LATEST_SEASONS_QUERY = gql`
  query PlayerGameKpisLatestSeasons($playerId: Int, $playerIds: [Int!], $seasonId: [Int]!, $kpiMasterId: [Int]) {
    playerGameKpisLatestSeasons(
      playerId: $playerId
      playerIds: $playerIds
      seasonId: $seasonId
      kpiMasterId: $kpiMasterId
    ) {
      gameId
      kpiMasterId
      playerId
      seasonId
      competitionId
      value
      matchDate
    }
  }
`;

export const PLAYER_ROLE_KPI_QUERY = gql`
  query PlayerRoleKpis($filter: PlayerRoleKpisInput) {
    playerRoleKpis(filter: $filter) {
      roleMasterId
      gameId
      kpiMasterId
      playerId
      value
    }
  }
`;

export const TEAM_COMPETITION_KPI_QUERY = gql`
  query TeamCompetitionKpis {
    teamCompetitionKpis {
      id
      competitionId
      seasonId
      kpiMasterId
      teamId
      value
    }
  }
`;

export const TEAM_COMPETITION_KPIS_FILTERED_QUERY = gql`
  query TeamCompetitionKpisFiltered($filter: TeamCompetitionKpisInput) {
    teamCompetitionKpis(filter: $filter) {
      competitionId
      seasonId
      kpiMasterId
      teamId
      value
    }
  }
`;

export const TEAM_GAME_KPI_QUERY = gql`
  query TeamGameKpis($filter: TeamGameKpisInput) {
    teamGameKpis(filter: $filter) {
      gameId
      kpiMasterId
      teamId
      value
    }
  }
`;

export const TEAM_GAME_KPIS_FILTERED_QUERY = gql`
  query TeamGameKpisMultiTeam($filter: TeamGameKpisInput!) {
    teamGameKpisMultiTeam(filter: $filter) {
      teamId
      seasonId
      competitionId
      gameId
      kpiMasterId
      value
      matchWeek
    }
  }
`;

export const TEAM_ROLE_KPI_QUERY = gql`
  query TeamRoleKpis {
    teamRoleKpis {
      id
      gameId
      formationMasterId
      kpiMasterId
      teamId
      value
      inPossession
    }
  }
`;

export const TEAM_GAME_KPIS = gql`
  query TeamGameKpis($filter: TeamGameKpisInput!) {
    teamGameKpis(filter: $filter) {
      gameId
      kpiMasterId
      teamId
      value
    }
  }
`;

export const PLAYER_COMPETITION_PHYSICAL_QUERY = gql`
  query PlayerCompetitionPhysical($filter: PlayerCompetitionPhysicalInput!) {
    playerCompetitionPhysical(filter: $filter) {
      competitionId
      seasonId
      teamId
      kpiMasterId
      playerId
      value
    }
  }
`;

export const TEAM_COMPETITION_PHYSICAL_QUERY = gql`
  query TeamCompetitionPhysical($filter: TeamCompetitionPhysicalInput) {
    teamCompetitionPhysical(filter: $filter) {
      competitionId
      seasonId
      kpiMasterId
      teamId
      value
    }
  }
`;
